import { render } from "./DashboardSettings.vue?vue&type=template&id=2df789d8&scoped=true"
import script from "./DashboardSettings.vue?vue&type=script&lang=js"
export * from "./DashboardSettings.vue?vue&type=script&lang=js"

import "./DashboardSettings.vue?vue&type=style&index=0&id=2df789d8&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df789d8"]])

export default __exports__